import { useState, FormEvent } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

function Form() {
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const userDetails = getUserDetails();
    
    /**
     * On form submit check fields are filled out.
     * Then set the loading state and pass the data back to node server.
     * Once we've done that await for a response and provide the user with a helpful message.
     *
     * @param e - Form submit event
     */
    function submitHandler(e: FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        
        const formElements = e.currentTarget.elements as any; // Type-casting to access elements
        const turnstileToken = formElements['cf-turnstile-response'] ? formElements['cf-turnstile-response'].value : '';
        
        if (!name || !email) {
            toast.error("Please ensure all fields are filled out");
            return;
        }
        
        setLoading(true);
        
        axios.post("https://info.castlegateit.co.uk/api/email.php", {
            name,
            email,
            userDetails,
            turnstileToken
        },)
        .then((response) => {
            if (response.status === 200) {
                console.log(response)
                setLoading(false);
                toast.success("Message sent successfully");
                setName('');
                setEmail('');
            } else {
                setLoading(false);
                toast.error("An unexpected error occurred, please try again");
            }
        })
        .catch(() => {
            setLoading(false);
            toast.error("An error occurred, please try again");
        });
    }
    
    return (
        <>
            <form className="col-form col col-md-4" onSubmit={submitHandler}>
                <ToastContainer position="top-center" limit={1} />
                <div className="form-col">
                    <label>Your Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                
                <div className="form-col">
                    <label>Your Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                
                <div
                    className="cf-turnstile"
                    data-sitekey="0x4AAAAAAAwpARtO1Wze95zv"
                    data-theme="light"
                ></div>
                
                <button
                    disabled={loading}
                    className="col"
                    type="submit"
                >
                    {loading ? "Submitting..." : "Submit"}
                </button>
            </form>
        </>
    );
}

/**
 * Loop over all the information cards and gather the user's submitted data.
 * Then return this as an object.
 *
 * @returns {Record<string, string>}
 */
function getUserDetails(): Record<string, string> {
    let cards = document.getElementsByClassName('information');
    let dataAttributes: Record<string, string> = {};
    
    Array.from(cards).forEach((element) => {
        let el = element as HTMLElement; // Type-casting to access dataset
        for (let attributeName in el.dataset) {
            if (el.dataset[attributeName]) {
                dataAttributes[attributeName] = el.dataset[attributeName]!;
            }
        }
    });
    
    return dataAttributes;
}

export default Form;
